import { render } from "./categoryMagazine.vue?vue&type=template&id=67c4a65e"
import script from "./categoryMagazine.vue?vue&type=script&lang=js"
export * from "./categoryMagazine.vue?vue&type=script&lang=js"

import "./categoryMagazine.vue?vue&type=style&index=0&id=67c4a65e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__